import type React from 'react';

export type CodeInputTranslations = {
  resendCode: string;
  confirm: string;
};

export const defaultCodeInputTranslations: CodeInputTranslations = {
  resendCode: 'Common.ContactValidation.CodeInput.ResendCode',
  confirm: 'Common.ContactValidation.CodeInput.Confirm',
};

export type CodeInputProps = {
  translations?: Partial<CodeInputTranslations>;
  codeValue: string;
  codeId: string;
  codeErrors?: string[];
  isValidating: boolean;
  isSending: boolean;
  captchaChallenge: boolean;
  onCaptchaChange: (token: string | null | undefined) => void;
  onCodeChange: (value: string) => void;
  onResend: () => void;
  onSubmit: React.EventHandler<React.SyntheticEvent<HTMLFormElement>>;
};
